import { Agencies, ContractTypes, HelpTypes, MiscType, setFilterPostedBy, setFilterShiftType, setMapProfessionalType } from '@pharmaplan/common';
import { useAppDispatch } from '../../useAppDispatch';

const useAdminCalendarDropdowns = () => {
  const dispatch = useAppDispatch();

  const handleMenuClick = (val: string) => {
    dispatch(setFilterShiftType(val as ContractTypes | MiscType));
  };

  const handleMapProfessionalFilter = (val: string) => {
    dispatch(setMapProfessionalType(val as HelpTypes | MiscType));
  };

  const handlePostedMenuClick = (val: string) => {
    dispatch(setFilterPostedBy(val as MiscType | Agencies));
  };

  return { handleMenuClick, handleMapProfessionalFilter, handlePostedMenuClick };
};

export default useAdminCalendarDropdowns;
